/**
 * If an img tag is unable to find the sales rep image, this sets the img src to the default avatar image.
 *
 * @param event {SyntheticEvent}: Browser event for HTMLImageElement -- the event passed to `onError`.
 *
 * @example
 *  <img src={`/images/${rep.name}.jpg`} onError={(event) => setFallbackAvatar(event)} />
 */
const setFallbackAvatar = (event) => {
    event.target.src = '/assets/avatar.png';
};

export default setFallbackAvatar;
